import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

export interface IGetCompanyAutoPOParams {
	companyId: number | string;
}

const initialState: boolean | null = null;

const companyAutoPOPath = "/passwordManager/Companies/IsAutoPOEnabled";

const buildExternalUrl = (params: IGetCompanyAutoPOParams) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	const searchParams = new URLSearchParams();
	searchParams.set("companyId", String(params.companyId));

	return `${baseUrl.replace(/\/$/, "")}/Companies/IsAutoPOEnabled?${searchParams.toString()}`;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getCompanyAutoPO, slice: companyAutoPOSlice } = getThunkAndSlice<
	IGetCompanyAutoPOParams,
	boolean,
	boolean | null
>({
	initialState,
	path: companyAutoPOPath,
	externalPath: buildExternalUrl,
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
